
import { supabase } from "@/lib/supabase";
import { v4 as uuidv4 } from 'uuid';
import { useToast } from "@/hooks/use-toast";

export const quillImageHandler = async () => {
  const input = document.createElement('input');
  input.setAttribute('type', 'file');
  input.setAttribute('accept', 'image/*');
  input.click();

  input.onchange = async () => {
    const file = input.files?.[0];
    if (!file) return;

    // Check file size (limit to 5MB)
    if (file.size > 5 * 1024 * 1024) {
      const { toast } = useToast();
      toast({
        title: "Error",
        description: "Image too large. Maximum size is 5MB.",
        variant: "destructive",
      });
      return;
    }

    try {
      // Generate a unique filename
      const fileExt = file.name.split('.').pop();
      const fileName = `${uuidv4()}.${fileExt}`;

      // Call the edge function to upload the image
      const formData = new FormData();
      formData.append('file', file);
      formData.append('fileName', fileName);

      const { data, error } = await supabase.functions.invoke('upload-signature-image', {
        body: formData,
      });

      if (error) throw error;

      // Get the image URL
      const quill = document.querySelector('.ql-editor')?.parentNode?.querySelector('.ql-editor');
      const range = document.getSelection();

      // Insert the image into the editor
      if (quill && range && data.publicUrl) {
        const editor = (window as any).Quill.find(quill);
        const index = range.anchorOffset;
        editor.insertEmbed(index, 'image', data.publicUrl);
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      const { toast } = useToast();
      toast({
        title: "Error",
        description: "Failed to upload image. Please try again.",
        variant: "destructive",
      });
    }
  };
};
